import { SurveyDetailItem } from './models/SurveyDetailItem'
import { SurveyListItem } from './models/SurveyListItem'
import {
  fetchAuthenticated,
  fetchAuthenticatedVoid,
  getAggregateUrl,
} from './sessionApi'
import { access } from '@inrupt/solid-client'

export const fetchSurveyListItems = (): Promise<SurveyListItem[]> => {
  return fetchAuthenticated<SurveyDetailItem[]>(getAggregateUrl('/surveys'), {
    method: 'GET',
  })
}

export const createNewSurvey = (id: string): Promise<void> => {
  return fetchAuthenticatedVoid(getAggregateUrl(`/surveys/${id}`), {
    method: 'PUT',
  })
}

export const fetchSurveyById = (id: string): Promise<SurveyDetailItem> => {
  return fetchAuthenticated<SurveyDetailItem>(
    getAggregateUrl(`/surveys/${id}`),
    {
      method: 'GET',
    }
  )
}

export const setSurveyAccess = (
  id: string,
  isPublic: boolean
): Promise<void> => {
  return fetchAuthenticatedVoid(getAggregateUrl(`/surveys/${id}/access`), {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      isPublic,
    }),
  })
}

export const getSurveyAccess = (id: string): Promise<access.Access> =>
  fetchAuthenticated<access.Access>(getAggregateUrl(`/surveys/${id}/access`), {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
    },
  })

export const createNewQuestion = (id: string): Promise<void> => {
  return fetchAuthenticatedVoid(getAggregateUrl(`/surveys/${id}/questions`), {
    method: 'POST',
  })
}

export const updateQuestion = ({
  id,
  questionUrl,
  text,
}: {
  id: string
  questionUrl: string
  text: string
}): Promise<void> => {
  return fetchAuthenticatedVoid(getAggregateUrl(`/surveys/${id}/questions`), {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      questionUrl,
      text,
    }),
  })
}

export const removeQuestion = ({
  id,
  questionUrl,
}: {
  id: string
  questionUrl: string
}): Promise<void> => {
  return fetchAuthenticatedVoid(
    getAggregateUrl(
      `/surveys/${id}/questions?questionUrl=${encodeURIComponent(questionUrl)}`
    ),
    {
      method: 'DELETE',
    }
  )
}
